import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"icon-plus\"><path fill=\"currentColor\" d=\"M12 .25c1.054 0 1.918.816 1.995 1.85l.005.15v8h8a2 2 0 01.15 3.995l-.15.005h-8v8a2 2 0 01-3.995.15L10 22.25v-8H2a2 2 0 01-.15-3.995L2 10.25h8v-8a2 2 0 012-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol